var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogFormVisible,
            width: _vm.formData.width,
            modal: true,
            "close-on-click-modal": false,
            "custom-class": "person",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "logo" }, [
              _c("img", { attrs: { src: _vm.rolesConfig.logo, alt: "" } }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "logo-text" }, [
              _vm._v(
                _vm._s(_vm.rolesConfig.name) +
                  " " +
                  _vm._s(_vm.$t("setting.enterprise04"))
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "w60" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.handleConfirm },
                  },
                  [_vm._v(_vm._s(_vm.$t("setting.enterprise05")))]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "w60" },
              [
                _c(
                  "el-button",
                  { attrs: { type: "text" }, on: { click: _vm.handleClose } },
                  [_vm._v(_vm._s(_vm.$t("setting.enterprise06")))]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            visible: _vm.dialogVisible,
            width: "30%",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("span", [_vm._v("是否需要完善信息？")]),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.goNow } },
                [_vm._v("立即前往")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }